// src/components/Auth/Auth.js

import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { sendOTP, verifyOTP } from '../../services/authService';
import { AuthContext } from '../../contexts/AuthContext';

function OTPLogin() {
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });
  const { setAuthTokens } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleSendOTP = (e) => {
    e.preventDefault();
    sendOTP(email)
      .then(() => {
        setOtpSent(true);
        setMessage({
          type: 'success',
          text: 'OTP sent to your email.',
        });
      })
      .catch(() => {
        setMessage({
          type: 'error',
          text: 'Error sending OTP.',
        });
      });
  };

  const handleVerifyOTP = (e) => {
    e.preventDefault();
    verifyOTP(email, code)
      .then((response) => {
        setMessage({
          type: 'success',
          text: 'OTP Verified. You are logged in.',
        });
        setAuthTokens(response.data);
        navigate('/dashboard');
      })
      .catch((error) => {
        setMessage({
          type: 'error',
          text: error.response?.data?.error || 'Invalid OTP.',
        });
      });
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-900">
      <div className="p-8 bg-white rounded shadow-lg w-96">
        <h2 className="mb-6 text-2xl font-bold text-center text-gray-700">
          Sign In
        </h2>
        {message.text && (
          <div
            className={`mb-4 px-4 py-2 text-white rounded ${message.type === 'success' ? 'bg-green-500' : 'bg-red-500'}`}
          >
            {message.text}
          </div>
        )}
        <form onSubmit={otpSent ? handleVerifyOTP : handleSendOTP}>
          <input
            type="email"
            placeholder="Email Address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="w-full px-4 py-2 mb-4 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            disabled={otpSent}
          />
          {otpSent && (
            <input
              type="text"
              placeholder="Enter OTP"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              required
              className="w-full px-4 py-2 mb-4 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          )}
          <button
            type="submit"
            className="w-full px-4 py-2 font-bold text-white bg-blue-600 rounded hover:bg-blue-700"
          >
            {otpSent ? 'Verify OTP' : 'Send OTP'}
          </button>
        </form>
        {otpSent && (
          <button
            onClick={() => {
              setOtpSent(false);
              setEmail('');
              setCode('');
              setMessage({ type: '', text: '' });
            }}
            className="w-full px-4 py-2 mt-4 font-bold text-blue-600 bg-transparent border border-blue-600 rounded hover:bg-blue-600 hover:text-white"
          >
            Use a different email
          </button>
        )}
        {/* Add option top move to password login or register page */}
      <div className="mt-4 text-center">
        Login with password?{' '}
        <a href="/login" className="text-blue-600 hover:underline">
          Login
        </a>

        <div className="mt-2 text-center">
          Or{' '}
          <a href="/register" className="text-blue-600 hover:underline">
            Register
          </a>

        </div>
      </div>
      </div>

      
    </div>
  );
}

export default OTPLogin;
